import { Component, OnInit } from '@angular/core';
import { AlertService, ComponentsStoreService, IAlertType } from '../../../_shared/services';
import { ClrDatagridModule, ClrDatagridSortOrder, ClrIconModule } from '@clr/angular';
import { Components } from '../../../_shared/interfaces';
import { RouterLink } from "@angular/router";
import { NgIf } from "@angular/common";
import { ClarityIcons, cogIcon, nodeIcon, twoWayArrowsIcon} from "@cds/core/icon";
import { ComponentSubnavComponent } from "../component-subnav/component-subnav.component";

@Component({
  selector: 'app-component-assembly',
  standalone: true,
  imports: [
    ClrDatagridModule,
    RouterLink,
    ClrIconModule,
    NgIf,
    ComponentSubnavComponent
  ],
  templateUrl: './component-assembly.component.html',
  styleUrl: './component-assembly.component.sass'
})
export class ComponentAssemblyComponent implements OnInit {
  components: Components[] = [];
  descSort = ClrDatagridSortOrder.DESC;
  loading: boolean = true;

  constructor(
    private compss: ComponentsStoreService,
    public alertDispatcher: AlertService
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon, nodeIcon, cogIcon);
  }

  ngOnInit(): void {
    this.loading = true;
    this.getAssemblies();
  }

  private getAssemblies() {
    this.compss.getAssemblies().subscribe({
      next: data => {
        if (!data || !data.object || data.object.length === 0) {
          this.alertDispatcher.show({
            message: ' Keine Baugruppen gefunden! ',
            clrAlertType: IAlertType.WARNING
          }, 2000);
        }
        this.components = data.object;
      },
      complete: () => {
        this.loading = false;
      },
      error: () => {
        return
      }
    })
  }
}
